export const CREATION_TYPE = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic',
}

export const RULEBASED_OBJECT_TYPE = {
  PRODUCT: 'product',
  TAGS: 'tags',
  COLLECTION: 'collection',
  VENDOR: 'vendor',
  PRODUCT_TYPE: 'productType',
}

export const CUSTOM_RECOMMENDATION_LOGIC = {
  SIMILAR_RECENTLY_VIEWED: 'similar_recently_viewed',
  COUPLE_OF_ALL: 'couple_of_all',
  ZIPCODE_REGION_TAG_TARGETTING: 'zipcode_region_tag_targetting',
  ECHODINING: 'echodining',
  ALWAYS_CHANGING_RECENT_TOP_PRODUCTS: 'always_changing_recent_top_products',
  CATEGORY_BESTSELLER: 'category_bestseller',
  RECENTLY_UPDATED: 'recently_updated',
  PERSONALIZED_WITH_PINNED: 'personalized_with_pinned',
  PERSONALIZED_WITH_RECENCY_SALES_PAGINATED: 'personalized_with_recency_sales_paginated',
}

export const RECOMMENDATIONS_RANKING_CRITERIA = {
  PERSONALISED: 'personalised',
  BESTSELLERS: 'bestsellers',
  NEW_ARRIVALS: 'new_arrivals',
  LOWEST_PRICED: 'lowest_priced',
  HIGHEST_PRICED: 'highest_priced',
}